module.exports = __webpack_public_path__ + "static/media/85B496B1-3E20-496F-9370-B0D380BB77B1_1625597482143.6dacdfd2.jpeg";